import { render, staticRenderFns } from "./TrainersPage.vue?vue&type=template&id=650950f5&"
import script from "./TrainersPage.vue?vue&type=script&lang=js&"
export * from "./TrainersPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainersPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports